const RAZORPAY_SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';
const RAZORPAY_SCRIPT_SELECTOR = `script[src="${RAZORPAY_SCRIPT_SRC}"]`;

const getScriptRefCount = (script) => Number(script?.dataset?.rzpRefCount || '0');

const setScriptRefCount = (script, count) => {
  script.dataset.rzpRefCount = String(Math.max(0, count));
};

const removeScriptIfUnused = () => {
  const script = document.querySelector(RAZORPAY_SCRIPT_SELECTOR);
  if (!script) {
    return;
  }

  if (getScriptRefCount(script) > 0) {
    return;
  }

  script.remove();

  // Best-effort cleanup of global symbol created by checkout.js.
  if (typeof window !== 'undefined' && Object.prototype.hasOwnProperty.call(window, 'Razorpay')) {
    try {
      delete window.Razorpay;
    } catch {
      window.Razorpay = undefined;
    }
  }
};

export const acquireRazorpayScript = ({ onLoaded, onError }) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  let script = document.querySelector(RAZORPAY_SCRIPT_SELECTOR);

  if (!script) {
    script = document.createElement('script');
    script.src = RAZORPAY_SCRIPT_SRC;
    script.async = true;
    setScriptRefCount(script, 0);
    document.body.appendChild(script);
  }

  setScriptRefCount(script, getScriptRefCount(script) + 1);

  const handleLoad = () => {
    if (typeof onLoaded === 'function') {
      onLoaded();
    }
  };

  const handleError = () => {
    if (typeof onError === 'function') {
      onError();
    }
  };

  script.addEventListener('load', handleLoad);
  script.addEventListener('error', handleError);

  if (window.Razorpay) {
    handleLoad();
  }

  return () => {
    script.removeEventListener('load', handleLoad);
    script.removeEventListener('error', handleError);
    setScriptRefCount(script, getScriptRefCount(script) - 1);
    removeScriptIfUnused();
  };
};
